import { EmptyApiState } from "./EmptyApiState";
import { CloudDownload } from "lucide-react";

export function VersionsTab() {
  return (
    <EmptyApiState
      title="Version catalog"
      description="The Apple GDMF version catalog (released OS versions, RSR, beta seeding) will appear here once the backend sync ships."
      icon={<CloudDownload className="h-5 w-5" aria-hidden="true" />}
    />
  );
}

export default VersionsTab;
